import { render, staticRenderFns } from "./SettingsSocial.vue?vue&type=template&id=2817ec7e&"
import script from "./SettingsSocial.vue?vue&type=script&lang=js&"
export * from "./SettingsSocial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports